// Shared look for the modern report layout. The agent's brand colors come from appState.colorPallete;
// these are the neutrals and the up/down colors that stay the same for every agent.
export const INK = "#1d2433";
export const INK_2 = "#4a5263";
export const MUTED = "#6b7385";
export const LINE = "#e6e9ef";
export const PAGE = "#f5f7fa";
export const UP = { fg: "#0f7a55", bg: "#e3f5ec" };
export const DOWN = { fg: "#b42318", bg: "#fdecea" };

export const cardSx = {
	backgroundColor: "#fff",
	border: `1px solid ${LINE}`,
	borderRadius: "16px",
};

export const labelSx = {
	fontSize: "11px",
	fontWeight: 700,
	letterSpacing: ".06em",
	textTransform: "uppercase" as const,
	color: MUTED,
};

export function isValidURL(str?: string) {
	if (!str) return false;
	try {
		new URL(str);
		return true;
	} catch (_) {
		return false;
	}
}

export function initials(name?: string) {
	return (name ?? "")
		.split(" ")
		.filter(Boolean)
		.map((token) => token[0])
		.join("")
		.slice(0, 2)
		.toUpperCase();
}

// "#16B380" -> "rgba(22, 179, 128, 0.2)"
export function withAlpha(hex: string, alpha: number) {
	const match = /^#?([0-9a-f]{6})$/i.exec(hex ?? "");
	if (!match) return `rgba(0, 0, 0, ${alpha})`;
	const n = parseInt(match[1], 16);
	return `rgba(${n >> 16}, ${(n >> 8) & 255}, ${n & 255}, ${alpha})`;
}
